




















































import { Component, Vue, Watch } from "vue-property-decorator";
import GenericBTable from "@/core/Generics/GenericBTable";
import BTableColumn from "@/models/base/BTableColumn.model";
import Period from "@/models/annoucement/period.Model";
import { BTableColumnType } from "@/enums/BTableColumnType";
import UserService from '../../services/user.service';
import { PermissionValue } from '../../enums/PermissionValue';
@Component
export default class InitperiodTableComponent extends GenericBTable<Period> {

  created() {
    this.permissionValue = PermissionValue.PERIODO;
    this.tableConfig.controller = "Periods";
  }

  mounted() {
    this.formatColumns();
  }

  formatColumns() {
    let periodoInit = new BTableColumn("periodName", "table.period", true);
    let periodoEnd = new BTableColumn("code", "table.code", true);
    this.tableConfig.insertColumns(periodoInit,periodoEnd);
    this.tableConfig.activeActions = this.permissionAccess.write;
    this.tableConfig.actions.customTemplate = this.permissionAccess.write;
  }
}
